import styled, { css } from 'styled-components';
import { DesignStyle } from '../../../types';

// CSS Custom Properties for theming
const cardDefaultVars = css`
    --card-border-color: #e5e7eb;
    --card-background-color: #ffffff;
    --card-color: #272b35;
    --card-hover-border-color: #9ca3af;
    --card-hover-background-color: #ffffff;
    --card-hover-color: #272b35;
`;

const cardStyledVars = css`
    --card-border-color: var(--color_1);
    --card-background-color: var(--color_4);
    --card-color: var(--color_1);
    --card-hover-border-color: var(--color_1);
    --card-hover-background-color: var(--color_4);
    --card-hover-color: var(--color_1);
`;

export const EventsList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 16px;
    list-style: none;
    padding-inline: 0;
    padding-block: 32px;
    margin-block: 1px;
`;

// Typography mixins
const titleTypography = css`
    font-weight: 550;
    font-size: 20px;
    line-height: 26px;
    letter-spacing: 0px;
`;

const bodyTypography = css`
    color: var(--card-color);
    font-weight: 350;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0px;
`;

// Layout mixins
const flexColumn = css`
    display: flex;
    flex-direction: column;
`;

const flexRow = css`
    display: flex;
    align-items: flex-start;
`;

// Reset and base styles
const resetStyles = css`
    margin: 0;
    padding: 0;
    box-sizing: border-box;
`;

export const Card = styled.li`
    ${cardDefaultVars}

    .${DesignStyle.SITE_THEME} & {
        ${cardStyledVars}
    }

    border: 1px solid var(--card-border-color);
    border-radius: 8px;
    padding: 24px;
    background: var(--card-background-color);
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;

    &:hover {
        border-color: var(--card-hover-border-color);
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
        transform: translateY(-1px);

        .${DesignStyle.SITE_THEME} & {
            border-color: var(--card-hover-border-color);
            background-color: var(--card-hover-background-color);
        }
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }

    &:active {
        transform: translateY(0px);
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
    }
`;

export const SkeletonCard = styled(Card)`
    cursor: default;
`;

export const CardContent = styled.div`
    ${flexRow}
    gap: 16px;
`;

export const MainContent = styled.div`
    ${flexColumn}
    gap: 12px;
    flex: 1;
`;

export const EventTitle = styled.h5`
    #dm && {
        ${resetStyles}
        ${titleTypography}
        color: var(--card-color);
        margin: 0;
        flex: 1;
    }

    #dm .${DesignStyle.SITE_THEME} && {
        color: var(--card-color);
    }
`;

export const EventPrice = styled.span`
    ${resetStyles}
    ${bodyTypography}
    flex-shrink: 0;
    align-self: flex-start;
`;

export const EventDescription = styled.p`
    ${resetStyles}
    ${bodyTypography}
    line-height: 1.5;
`;

export const EventDuration = styled.span`
    ${resetStyles}
    ${bodyTypography}
`;

// CSS Custom Properties for theming
const selectStepDefaultVars = css`
    --select-step-background-color: #ffffff;
    --select-step-border-color: #e5e7eb;
    --select-step-color: #272b35;
    --select-step-grouped-events-title-background-color: #ffffff;
    --select-step-grouped-events-title-color: #272b35;
`;

const selectStepStyledVars = css`
    --select-step-background-color: var(--color_3);
    --select-step-border-color: var(--color_1);
    --select-step-color: var(--color_1);
    --select-step-grouped-events-title-background-color: var(--color_3);
    --select-step-grouped-events-title-color: var(--color_1);
`;

export const OuterContainer = styled.div`
    ${selectStepDefaultVars}

    .${DesignStyle.SITE_THEME} & {
        ${selectStepStyledVars}
    }

    padding-inline: 32px;
    width: 100%;
    border-width: 1px;
    border-style: solid;
    border-radius: 6px;
    background-color: var(--select-step-background-color);
    border-color: var(--select-step-border-color);
    color: var(--select-step-color);
    overflow: auto;
`;
